import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

const PropertySubmissionSuccess: React.FC = () => {
  const history = useHistory()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  const handleDownloadApp = () => {
    window.open('https://www.haupcar.com/download', '_blank', 'noopener,noreferrer')
  }

  const handleManageProperty = () => {
    window.open('https://app.haupcar.com', '_blank', 'noopener,noreferrer')
  }

  const handleLineClick = () => {
    const lineId = '@haup.partner'
    const lineAppUrl = `https://line.me/R/ti/p/${lineId}?openQrModal=true`

    window.open(lineAppUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        fontFamily: 'Poppins, sans-serif',
        backgroundImage: `url('/static/media/loginbg.9f35eb74.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: '#F9FAFB',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '500px',
          margin: '0 auto',
          backgroundColor: 'white',
          minHeight: '100vh',
          padding: '24px 16px',
          boxSizing: 'border-box',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            marginBottom: '32px',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)',
            transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s',
          }}
        >
          <h1
            style={{
              fontSize: '24px',
              fontWeight: '600',
              color: '#212427',
              margin: 0,
              lineHeight: '1.3',
              letterSpacing: '-0.5px',
              fontFamily: 'Poppins, sans-serif',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.6s ease-out 0.8s, transform 0.6s ease-out 0.8s',
            }}
          >
            Success! Your property is now listed on our platform.
          </h1>
        </div>

        <div
          onClick={handleLineClick}
          style={{
            backgroundColor: '#F9FAFB',
            padding: '20px',
            borderRadius: '12px',
            marginBottom: '24px',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.6s ease-out 1s, transform 0.6s ease-out 1s',
            cursor: 'pointer',
          }}
        >
          <h3
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#212427',
              margin: '0 0 12px 0',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Connect with us on LINE
          </h3>
          <p
            style={{
              fontSize: '14px',
              color: '#667085',
              margin: '0 0 16px 0',
              lineHeight: '1.5',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Before continuing the remaining step, please connect with us on LINE. Our team will
            guide you through the process and help you follow up on your request directly.
          </p>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              backgroundColor: 'white',
              borderRadius: '20px',
              border: '1px solid #D6DAE0',
            }}
          >
            <img
              src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/2STEKm69TTk5QToL4AmdhRTG6j8SAojhp9Vbh3FbNw4Ucyv7SsiFN9iREdhgkGNX5moyRkVMRm6r3Ts1rENRyByX.png"
              alt="LINE"
              style={{ width: '20px', height: '20px' }}
            />
            <span
              style={{
                fontSize: '14px',
                color: '#374151',
                fontFamily: 'Poppins, sans-serif',
              }}
            >
              @haup.partner
            </span>
          </div>
        </div>

        <div
          style={{
            width: '100%',
            padding: '20px',
            backgroundColor: '#F9FAFB',
            borderRadius: '12px',
            marginBottom: '24px',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.6s ease-out 1.2s, transform 0.6s ease-out 1.2s',
          }}
        >
          <h2
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#212427',
              margin: '0 0 20px 0',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Remaining steps to finish
          </h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <img
                src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/3HXxGXbyeasfDnr3ewK3Pv4mtpeg4Dr6bzyryscaxQ63ztw7LZfzNbdgJbyNZZxQwXyvmLtpt5yChUNWye89oJqw.png"
                alt="Check"
                style={{ width: '20px', height: '20px', marginTop: '2px' }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#212427',
                    lineHeight: '1.4',
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  Submission completed
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <img
                src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/3HXxGXbyeasfDnr3ewK3Pv4mtpeg4Dr6bzyryscaxQ63ztw7LZfzNbdgJbyNZZxQwXyvmLtpt5yChUNWye89oJqw.png"
                alt="Check"
                style={{ width: '20px', height: '20px', marginTop: '2px' }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#212427',
                    lineHeight: '1.4',
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  Your property is listed on the platform
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <img
                src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/3HXxGXbyeasfDnr3ewK3Pv4mtpeg4Dr6bzyryscaxQ63ztw7LZfzNbdgJbyNZZxQwXyvmLtpt5yChUNWye89oJqw.png"
                alt="Check"
                style={{ width: '20px', height: '20px', marginTop: '2px' }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#212427',
                    lineHeight: '1.4',
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  Upload required documents
                </div>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#667085',
                    margin: '4px 0 0 0',
                    lineHeight: '1.4',
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  Complete uploading required documents before you received the incoming booking
                  requests.
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  border: '2px solid #D6DAE0',
                  backgroundColor: 'white',
                  marginTop: '2px',
                }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '4px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: '500',
                      color: '#212427',
                      lineHeight: '1.4',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    Download app
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      fontWeight: '600',
                      color: '#856A00',
                      backgroundColor: '#FFF4CB',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    Incomplete
                  </span>
                </div>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#667085',
                    margin: '0 0 12px 0',
                    lineHeight: '1.4',
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  You need to download our app to manage property listings, respond to requests and
                  track earnings
                </p>
                <button
                  onClick={handleDownloadApp}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: 'transparent',
                    color: '#4C4848',
                    border: '1px solid #4C4848',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '12px',
                    fontFamily: 'Poppins, sans-serif',
                    transition: 'all 0.2s ease',
                  }}
                >
                  Download app
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button
            onClick={() => history.push('/submission#property')}
            style={{
              flex: '1',
              padding: '14px 24px',
              backgroundColor: 'transparent',
              color: '#4C4848',
              border: '1px solid #4C4848',
              borderRadius: '24px',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '16px',
              fontFamily: 'Poppins, sans-serif',
              transition: 'all 0.2s ease',
              transform: 'scale(1)',
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = 'scale(0.95)'
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
            }}
          >
            Back to Home
          </button>
          <button
            onClick={handleManageProperty}
            style={{
              flex: '1',
              padding: '14px 24px',
              backgroundColor: '#4C4848',
              color: 'white',
              border: 'none',
              borderRadius: '24px',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '16px',
              fontFamily: 'Poppins, sans-serif',
              transition: 'all 0.2s ease, opacity 0.6s ease-out 1.4s, transform 0.6s ease-out 1.4s',
              transform: isVisible ? 'scale(1) translateY(0)' : 'scale(0.95) translateY(20px)',
              boxShadow: '0 2px 8px rgba(183, 135, 90, 0.3)',
              opacity: isVisible ? 1 : 0,
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = isVisible
                ? 'scale(0.95) translateY(0)'
                : 'scale(0.9) translateY(20px)'
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = isVisible
                ? 'scale(1) translateY(0)'
                : 'scale(0.95) translateY(20px)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = isVisible
                ? 'scale(1) translateY(0)'
                : 'scale(0.95) translateY(20px)'
            }}
          >
            Manage Property
          </button>
        </div>
      </div>
    </div>
  )
}

export default PropertySubmissionSuccess
